//---------------------------------------------------
//  Nom du fichier : Acceuil.js 
//
//  Description: Page Acceuil qui contient la map, la recherche et
//               les boutons pour aller vers les autres pages
//
//  Auteur: Alek Del Balso et Vega Laliberté
//---------------------------------------------------

import { useState , useEffect} from 'react';
import Map from './Map';
import Publication from './Publication';  
import CreatePublication from './CreatePublication.js';  
import NotConnected from './NotConnected.js';
import Connected from './Connected.js';
import Login from './Login.js';
import SignIn from './SignIn.js';
import SearchSection from './SearchSection.js';

import { useParams } from "react-router-dom";
import { latLng } from 'leaflet';

const Acceuil = ({gradeType,setGradeType,loggedIn,setLoggedIn,
                  publication,setPublication,markers,creatingPublication,
                  setcreatingPublication,destination,
                  setDestination,render_markers, connectWebSocket, 
                  newMessages,imagePath,setImagePath}) => {
                    
  let { post_id } = useParams(); 
  const [login, setLogin] = useState(false);  
  const [singIn, setSignIn] = useState(false);  
  const [creatingMode, setCreatingMode] = useState(false);
  const [showSearch, setShowSearch] = useState(false)
  const [mapInstance, setMapInstance] = useState(null);
  const [position, setPosition] = useState(null);

  
  useEffect(() => {
    if(post_id != undefined && mapInstance != null){
      if(post_id == 'login'){
        setLogin(true)
        return
      }

      let values = post_id.split("_")
      setPublication(values[0])
      mapInstance.flyTo(latLng(parseFloat(values[1]), parseFloat(values[2])), mapInstance.getZoom(), {
        duration: 2 // Durée de l'animation en secondes
      })
    }
  }, [post_id, mapInstance]);


  const sign_out = () => {

    //unique pour le signout
    fetch("https://rockstoclimb.com/Backend/AjaxFolder/AjaxRead.php?logout=true", {
      method: "POST",
      credentials: "include",
      }) 
        .then(response => response.json())
        .then(data => {
          setLoggedIn(false)
          setLogin(false)
          setSignIn(false)

          setGradeType('american')
          setImagePath(null)
          localStorage.setItem("user_id",-1)
          localStorage.setItem("role", 2)
        })
        .catch(error => console.error("Error fetching session:", error));
  }

  return (
    <>
          <Map  openPublication={setPublication} 
                isLoggedIn={loggedIn} 
                set_create_publication={setcreatingPublication} 
                setCreatingMode={setCreatingMode} 
                creatingMode={creatingMode} 
                creatingPublication={creatingPublication} 
                destination={destination} 
                setDestination={setDestination} 
                markers={markers} 
                publication={publication}
                mapInstance={mapInstance}
                setMapInstance={setMapInstance}
                post_id={post_id}
                position={position}
                setPosition={setPosition}/>

          {creatingPublication && 
          <CreatePublication  set_publication={setcreatingPublication} 
                              info={creatingPublication} 
                              grade_type={gradeType} 
                              render_markers={render_markers}/>}
  
          {publication && 
          <Publication  setDestination={setDestination} 
                        post_id={publication} 
                        set_publication={setPublication}  
                        grade_type={gradeType} 
                        render_markers={render_markers}
                        setCreatingPublication={setcreatingPublication}
                        setLogin={setLogin}
                        fromAcceuil={true}/>}
  
          {!loggedIn && 
          <NotConnected set_login={setLogin} 
                        set_SignIn={setSignIn} 
                        _login={login} 
                        _signIn={singIn}/>}
  
          {loggedIn && !publication && !creatingPublication && !creatingMode && !destination && 
          <Connected  signOut={sign_out} 
                      imagePath={imagePath}
                      setShowSearch={setShowSearch}
                      isShowing={showSearch}
                      newMessages={newMessages}/>}
  
          {!loggedIn && login && 
          <Login  setLoggedIn={setLoggedIn} 
                  setGradeType={setGradeType} 
                  openLogin={setLogin}
                  setImagePath={setImagePath}
                  connectWebSocket={connectWebSocket}/>}
  
          {!loggedIn && singIn && 
          <SignIn setLoggedIn={setLoggedIn} 
                  setGradeType={setGradeType} 
                  openSignIn={setSignIn}
                  setImagePath={setImagePath}
                  connectWebSocket={connectWebSocket}/>}
  
            {loggedIn && !publication && !destination && !creatingMode &&
            <SearchSection set_publication={setPublication} 
                           showSearch={showSearch} 
                           grade_type={gradeType} 
                           setShowSearch={setShowSearch}
                           position={position}/>
            }

        </>
  );
};

export default Acceuil;